module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [_c('page-content', {
    ref: "pageContent",
    attrs: {
      "organizations": _vm.organizations,
      "viewingEvents": _vm.viewingEvents,
      "isEmptyCartPhotos": _vm.isEmptyCartPhotos,
      "pageType": "Viewing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('h3', {
    staticClass: "h6 font-size-1 mb-1"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_1'][13]"
    }
  })], 1), _vm._v(" "), _c('button', {
    ref: "toggleShoolCodePopoverFormBtn",
    staticClass: "btn-add-school-code btn w-100 btn-lg btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShoolCodePopoverForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_1'][14]"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('add-school-code-popover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowShoolCodePopoverForm),
      expression: "isShowShoolCodePopoverForm"
    }],
    ref: "shoolCodePopoverForm",
    on: {
      "fetchOrganization": _vm.fetchOrganization
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0696e808!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/Event/Viewing.vue
// module id = 666
// module chunks = 0